import { FC } from "react";
import { ViewContent } from "../shared/view-content/view-content";
import { usePatientProfileWidget } from "../../hooks/use-patient-profile-widget";
import CommsFilterWidget from "../../../comm-filter-widget/comms-filter-widget";
import { WidgetRoutePath } from "../../navigation/route-config";

export const InboxFiltersView: FC = () => {
  const { goTo } = usePatientProfileWidget();

  return <ViewContent>
    <CommsFilterWidget onFilterApplied={() => goTo(WidgetRoutePath.INBOX)} />
  </ViewContent>
}
